import InternetTest from "./internet";
import GamepadTest from "./gamepad";
export default {
  internet: InternetTest,
  gamepad: GamepadTest
};